import React from 'react';
import {
    TableCell,
    TableRow,
} from 'material-ui';
import {
    capitalizeFirstLetter,
} from "../../components/helpers/helpers";
import MenusTableItemActions from './MenusTableItemActions';

class MenusTableContent extends React.Component {

    render() {
        const {
            classes,
            menu,
            sites,
            handleClickOpen
        } = this.props;

        return (
            <TableRow hover={true}>
                <TableCell className={classes.tableCell}>{menu.id}</TableCell>
                <TableCell className={classes.tableCell}>{capitalizeFirstLetter(menu.type.name)}</TableCell>
                <TableCell className={classes.tableCell}>{menu.site.name}</TableCell>
                <MenusTableItemActions
                    menu={menu}
                    sites={sites}
                    classes={classes}
                    handleClickOpen={handleClickOpen}
                />
            </TableRow>
        )
    }
}

export default MenusTableContent;


// WEBPACK FOOTER //
// ./src/containers/menus/MenusTableItem.jsx